<div class="neo-details-carousel-container">
    <div class="neo-details-carousel" (mouseenter)="clearAutoPlay()" (mouseleave)="startAutoPlay()">
        <div class="carousel-header">
            <div class="carousel-header-icon">
                <i [class]="carouselDetails[activeCarousel].header.icon"></i>
            </div>
            <div class="carousel-header-text">
                {{carouselDetails[activeCarousel].header.text}}
            </div>
        </div>
        <div class="carousel-content">
            <div class="carousel-content-list">
                <ul>
                    @for (list of carouselDetails[activeCarousel].content.list; track $index) {
                    <li>{{list}}</li>
                    }
                </ul>
            </div>
        </div>
        <div class="carousel-footer">
            @for (footer of carouselDetails[activeCarousel].footer; track $index) {
            <div class="carousel-footer-item">
                {{footer | uppercase}}
            </div>
            }
        </div>
    </div>
    <div class="neo-details-carousel-indicators">
        @for (indicator of carouselDetails; track $index) {
        <div class="carousel-indicator" [class.active]="$index === activeCarousel" (click)="changeActiveIndex($index)"></div>
        }
    </div>
</div>